require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")

window.$ = window.jQuery = require('jquery');
window.moment = require('moment');
require("jquery-mask-plugin")

import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css"

import toastr from 'toastr/toastr';
window.toastr = toastr;
import 'bootstrap-daterangepicker';

$.jMaskGlobals.watchDataMask = true;

// Sidebar toggle
function isMobile() { return window.innerWidth <= 768; }

function closeMobileSidebar() {
  document.body.classList.remove('sidebar-mobile-open');
}

function setSidebarCookie(collapsed) {
  // 1 ano, path raiz — o layout lê esse cookie no servidor para já
  // renderizar o <body> com a classe certa e evitar o flash de
  // abre/fecha que acontecia quando o estado só existia no localStorage.
  document.cookie = 'sidebar_collapsed=' + (collapsed ? '1' : '0') + '; max-age=31536000; path=/';
}

document.addEventListener('DOMContentLoaded', () => {
  // No mobile a sidebar nunca começa colapsada via classe de servidor;
  // garante que o estado herdado do desktop não vaze para a view mobile.
  if (isMobile()) {
    document.body.classList.remove('sidebar-collapsed');
  }

  const toggle = document.getElementById('sidebarToggle');
  if (toggle) {
    toggle.addEventListener('click', () => {
      if (isMobile()) {
        document.body.classList.toggle('sidebar-mobile-open');
      } else {
        document.body.classList.toggle('sidebar-collapsed');
        const collapsed = document.body.classList.contains('sidebar-collapsed');
        setSidebarCookie(collapsed);
        setTimeout(() => { if (window._revenueChart) window._revenueChart.resize(); }, 270);
      }
    });
  }

  // Fecha sidebar mobile ao redimensionar para desktop
  window.addEventListener('resize', () => {
    if (!isMobile()) {
      document.body.classList.remove('sidebar-mobile-open');
    }
  });
});